import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { Conversation } from './services/conversation';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header,Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
 
  protected readonly title = signal('bainescredit-mcp-messages');
  isLoginPage = false;

  constructor(private conversationService: Conversation,private router: Router) {
    
  
  
  }


   ngOnInit(): void {
  //   this.conversationService.getConversations().subscribe({
  //     next: (conversations) => console.log('Conversations:', conversations),
  //     error: (error) => console.error('Error fetching conversations:', error)
  //   });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // console.log(event)
        this.isLoginPage = event.urlAfterRedirects === '/login';
      });
   }
}
